import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const BreadcrumbContext = createContext({ detail: null, setDetail: () => {} });

export function BreadcrumbProvider({ children }) {
  const [detail, setDetailRaw] = useState(null);
  const setDetail = useCallback((d) => setDetailRaw(d), []);
  const value = useMemo(() => ({ detail, setDetail }), [detail, setDetail]);
  return <BreadcrumbContext.Provider value={value}>{children}</BreadcrumbContext.Provider>;
}

BreadcrumbProvider.propTypes = { children: PropTypes.node };

export function useBreadcrumb() {
  return useContext(BreadcrumbContext);
}
